export default {
  title: 'Ustawienia napiwków',
  form: {
    has_tips: {
      label: 'Zezwól na napiwki',
    },
    default_tip_percentage: {
      label: 'Wstępnie wybrany poziom napiwku',
      tooltip: 'To poziom, który zostanie wstępnie wybrany dla klienta na ekranie płatności',
    },
    is_tip_hidden_on_receipt: {
      label: 'Napiwki niewidoczne na paragonach',
      tooltip: 'Po włączeniu ukrywa napiwki na drukowanych paragonach i w oknie informacji o zamówieniu',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
